<template>
    <div class="flex-1 flex flex-col gap-4 overflow-auto group-data-[state=collapsed]/sidebar-wrapper:overflow-hidden w-[--sidebar-width] group-data-[variant=overlay]/sidebar-wrapper:!w-full">
        <slot />
    </div>
</template>